import { render, staticRenderFns } from "./CarExtraForm.vue?vue&type=template&id=0ec7f278&scoped=true"
import script from "./CarExtraForm.vue?vue&type=script&lang=js"
export * from "./CarExtraForm.vue?vue&type=script&lang=js"
import style0 from "./CarExtraForm.vue?vue&type=style&index=0&id=0ec7f278&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec7f278",
  null
  
)

export default component.exports